export default class QuotePortSelections {

    constructor() {

        this.originCountry = '';
        this.destinationCountry = '';
        this.originPort = '';
        this.originSelection = '';
        this.destinationPort = '';
        this.destinationSelection = '';
        this.currencySelect = '';
    }
}